export const environment = {
  production: true,
  TILE_SERVER_URL: 'https://maps.geoapify.com/v1/tile/osm-bright/{z}/{x}/{y}.png?apiKey=',
  GEOCODING_SERVER_URL: 'https://api.geoapify.com/v1/geocode/search?',
  GEOAPIFY_API_KEY: '73cee4c9f2ca40bba7a075cd5ae18293',
  API_URL: "/ssp/"
};
